






















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DepositModel } from '@/models/deposit';
import formatNumber from '@/shared/filters/format-number';
import Voucher from "@/shared/components/Voucher.vue";
import commonService from '@/services/common-services';

@Component({
    components: {
        'voucher-popup': Voucher
    }
})
export default class AmountDetailDeposit extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;
    private voucherPopup = false;
    get payment() {
        return this.deposit.payment > 0 ? formatNumber(this.deposit.payment, '0,0') + '' : '0';
    }
    @Watch('order', { immediate: true, deep: true })
    private async watchOrder() {
        if(this.deposit && !this.deposit.voucherAmount && (this.deposit.status == 7 || (this.deposit.status == 9 && this.deposit.totalPriceVND > this.deposit.payment))) {
            this.openVoucherPopup();
        }
    }
    private async openVoucherPopup() {
        await this.getAvailableVouchers();
        this.voucherPopup = true;
    }
    private async getAvailableVouchers() {
        const result = await commonService.getAvailableVouchers(this.deposit.id, 2);
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_AVAILABLE_VOUCHER', result.data.data);
        }
    }

}
